import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import UniThumbGridBox from "./components/uni_thumb_grid_box";
import styles from "./uni_profile_uni_box.module.scss";

export const UniProfileUniBox = ({ universities }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className={styles.section_uni_profile_box}>
      <div className={styles.uni_profile_box}>
        <Slider {...settings}>
          {universities?.slice(0, 10).map((university, i) => (
            <UniThumbGridBox
              key={university.id}
              universityLink={`/study/${university?.country?.slug}/university/${university?.slug}`}
              name={university?.name}
              featuredImage={university?.featuredImage?.src}
              featuredImageAlt={university?.featuredImage?.alt}
              logo={university?.logo?.src}
              logoAlt={university?.logo?.alt}
              address={university?.address}
              city={university?.city?.name || "City"}
              state={university?.state?.name || "State"}
              country={university?.country?.name || "Country"}
              universityType={university.universityType}
              estd={university?.estd}
              courseLink={`/study/${university?.country?.slug}/university/${university?.slug}/courses`}
              courseNumber={university.course.length}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default UniProfileUniBox;
